import React, { Component } from "react";
import "./otherloandashboard.css";
import { t } from "i18next";
import {
  BreadCrumb,
  Button,
  Header,
  TitleView,
  Toast,
  ProgressDialog,
  CardDetailContainer,
  SideModel,
} from "../../components";
import * as Bl from "../../../businesslogic";
import {
  getFormatAmount,
  getLiabilityPathName,
  getUserId,
} from "../../common";
import { LIABILITIES_CATEGORY } from "../../constants";
import * as logger from "../../utils/logger/index";

class OtherLoanDashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liabilityData: [],
    };
    this.isRenderingAlready = false;
  }

  componentDidMount() {
    if (!this.isRenderingAlready) {
      this.isRenderingAlready = true;
      this.getUserLiabilityByCategory();
    }
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddMoreView() {
    this.props.navigate("/otherloanhome");
  }

  onPressFinishButton() {
    this.props.navigate("/financialdetails");
  }

  onClickEditIcon = (selectedItem) => {
    this.props.navigate("/otherloandetail", {
      state: { liabilityData: selectedItem.item, isEditView: true },
    });
  };

  onPressNo = () => {
    //To Do implement the function
  };

  onPressYes = (selectedItem) => {
    this.deleteLiability(selectedItem.item);
  };

  hideToast() {
    this.setState({ toastMessage: "", showToast: false });
  }
  showToast(toastMessage) {
    this.setState(
      { toastMessage, showToast: true, showProgress: false },
      () => {
        setTimeout(() => {
          this.hideToast();
        }, 3000);
      }
    );
  }

  getTotalBalance(list) {
    const totalArray = [];
    list.forEach((item) => {
      totalArray.push({
        money: item.currentvalue,
      });
    });
    const total = totalArray.reduce((a, v) => (a = a + v.money), 0);
    return total;
  }
  deleteLiability(item) {
    const liabilityObj = new Bl.Liability(item);
    this.setState({ showProgress: true }, () => {
      liabilityObj
        .deleteLiability()
        .then((response) => {
          const liabilityData = this.state.liabilityData;
          const updatedLiabilityData = liabilityData.filter(
            (liability) => liability.id !== item.id
          );
          this.setState({
            liabilityData: updatedLiabilityData,
            showProgress: false,
          });
        })
        .catch((error) => {
          logger.error({error})
          this.showToast(t("someErrorHasOccured"));
        });
    });
  }
  getUserLiabilityByCategory() {
    const data = {
      uuid: getUserId(),
      category: LIABILITIES_CATEGORY.OTHER_LIABILITIES,
    };
    this.setState({ showProgress: true }, () => {
      Bl.Liability.getUserLiabilityByCategory(data)
        .then((list) => {
          this.setState({ showProgress: false, liabilityData: list });
        })
        .catch((error) => {
          logger.error({error})
          this.showToast(t("someErrorHasOccured"));
        });
    });
  }
  prepareCardData(list) {
    const displayData = [];
    list.forEach((item) => {
      displayData.push({
        title: item.description,
        currencyLabel: "Current O/S Balance",
        money: item.currentvalue,
        period: item.maturityyear,
        item: item,
      });
    });
    return displayData;
  }
  renderNavView() {
    const items = getLiabilityPathName("OtherLiabilities");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("oloanTitle");
    return <TitleView title={title} information={""} />;
  }

  renderExpectedValueView() {
    const totalBalance = this.getTotalBalance(this.state.liabilityData);
    const displayAmount = getFormatAmount(totalBalance);
    return (
      <div className="odb_expect_value_view">
        <label className="odb_value_text">
          {t("oloanTotalValue")}: ₹ {displayAmount}
        </label>
      </div>
    );
  }

  renderCardView() {
    const cardData = this.prepareCardData(this.state.liabilityData);
    return (
      <div className="odb_card_view">
        {cardData.map((card, index) => (
          <CardDetailContainer
            key={index}
            title={card.title}
            currentValue={card.currencyLabel}
            money={card.money}
            period={card.period}
            extraContent={card.extraContent}
            onClickEdit={() => this.onClickEditIcon(card)}
            onPressNo={this.onPressNo.bind(this)}
            onPressYes={() => this.onPressYes(card)}
          />
        ))}
      </div>
    );
  }

  renderContentView() {
    return (
      <div className="odb_content_view">
        {this.renderTitleView()}
        {this.renderExpectedValueView()}
        {this.renderCardView()}
      </div>
    );
  }

  renderButtonsView() {
    return (
      <div className="odb_bottomView">
        <div className="odb_buttonView">
          <div className="odb_addmore_button">
            <Button
              buttonName={t("oloanDBButton1")}
              emptyButton={true}
              onPressButton={this.onPressAddMoreView.bind(this)}
            />
          </div>
          <div className="odb_save">
            <Button
              buttonName={t("oloanDBButton2")}
              onPressButton={this.onPressFinishButton.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  renderToastView() {
    return (
      <Toast
        showToast={this.state.showToast}
        toastMessage={this.state.toastMessage}
      />
    );
  }
  renderProgressDialog() {
    return (
      <ProgressDialog
        showProgress={this.state.showProgress}
        progressMessage={this.state.progressMessage}
      />
    );
  }
  render() {
    return (
      <div className="odb_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {this.renderButtonsView()}
        {/* {this.renderDrawerContent()} */}
        {this.renderToastView()}
        {this.renderProgressDialog()}
      </div>
    );
  }
}

export default OtherLoanDashBoard;
